import { ArrayUtils } from '@everyboard/lib';
import { MoveGenerator } from '../../../jscaip/AI/AI';
export class CheckersMoveGenerator extends MoveGenerator {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getListMoves(node, config) {
        const captures = this.getLegalCaptures(node.gameState, config);
        if (captures.length > 0) {
            return captures;
        }
        else {
            return this.rules.getSteps(node.gameState, config);
        }
    }
    getLegalCaptures(state, config) {
        const possibleCaptures = this.rules.getCompleteCaptures(state, config);
        if (config.mustMakeMaximalCapture) {
            return ArrayUtils.maximumsBy(possibleCaptures, (m) => m.coords.length);
        }
        else {
            return possibleCaptures;
        }
    }
}
